module.exports = __webpack_public_path__ + "static/media/buffet16.7f8065d9.jpg";